import { IProjectSquad } from '../models/projectSquad.model';
import { PageFilter } from '../state/app';
import { ProjectSquadListFilter } from '../state/projectSquad';
import axios from '../utils/axios';

const baseUrl = `/api/smProjectSquads`;

export const createProjectSquad = async (projectSquad: IProjectSquad) => {
  const requestUrl = `${baseUrl}`;
  return await axios.post(requestUrl, projectSquad);
};

export const fetchProjectSquad = async (id: IProjectSquad['id']) => {
  const requestUrl = `${baseUrl}/${id}`;
  return await axios.get(requestUrl);
};

export const fetchProjectSquadList = async ({
  filters,
  paging,
}: {
  filters: ProjectSquadListFilter;
  paging: PageFilter;
}) => {
  const params = new URLSearchParams();
  params.append('cacheBuster', new Date().getTime().toString());
  params.append('pageSize', paging.pageSize.toString());
  params.append('pageNumber', paging.pageNumber.toString());

  Object.entries(filters).forEach(([key, value]) => {
    params.append(key, value);
  });

  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};

export const deleteProjectSquad = async (id: number) => {
  const requestUrl = `${baseUrl}/${id}`;
  return await axios.delete(requestUrl);
};

export const updateProjectSquad = async (projectSquad: IProjectSquad) => {
  const requestUrl = `${baseUrl}`;
  return await axios.put(requestUrl, projectSquad);
};
